import ArtSection from "../Components/arts-section/index.section";
export default function Custom404() {
    return (
        <>
            <><title>لینک نامشخص</title></>
            <div className="py-12" style={{ backgroundImage: "url('/images/404bg.jpg')" }}>
                <div className="container">
                    <div className="text-center max-w-[900px] mx-auto bg-gray-100 shadow-lg p-4 rounded-lg">
                        <div className="w-full h-full rounded-lg overflow-hidden">
                            <img src='images/404_scream.jpg' width={100} height={100}
                                layout='responsive'
                                style={{ width: '100%', height: 'auto' }} // optional
                                alt="Not Found" />
                        </div>
                        <p className="my-8 text-lg">.با عرض پوزش، ما نتوانستیم صفحه مورد نظر شما را پیدا کنیم</p>
                        <p dir="auto">لطفاً لینک را برای اشتباهات املایی بررسی کنید. اگر این یک اشتباه از طرف ما باشد،</p>
                        <p dir="auto">لطفا با ما تماس بگیرید</p>
                    </div>
                    <ArtSection title=' ' withMore={false} />
                </div>
            </div>
        </>
    )
}